// mainly for amount, time
import moment from "moment";
import { parseInt, isArray, includes } from "./polyfill";
import { getRealTimeDiff } from "./date";

// const addComma = target => {
//   return target.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
// };

const setRealTimeDiff = target => {
  setTimeout(setRealTimeDiff, 1000, target);
  try {
    target.timeDiff = getRealTimeDiff(target.tx_created_time);
  } catch (e) {
    console.log("set time error", e);
    console.log(target);
  }
};

const convertDigits = amount => {
  let splitedStr = amount.toString().split("e")[1];
  let fixedNum = Math.abs(parseInt(splitedStr));
  return amount.toFixed(fixedNum);
};

const convertFuncPack = {
  amount: target => {
    switch (isArray(target)) {
      case true:
        target.forEach(item => {
          item.amount = convertAmountFormat(item.amount);
        });
        break;
      case false:
        target.amount = convertAmountFormat(target.amount);
        break;
    }
  },

  timeDiff: target => {
    switch (isArray(target)) {
      case true:
        target.forEach(item => {
          setRealTimeDiff(item);
        });
        break;
      case false:
        setRealTimeDiff(target);
        break;
    }
  },

  balanceLogToTransfer: transfers => {
    for (let t of transfers) {
      t.from_address = t.address
      t.to_address = t.rid
      if (t.type == 0) { // mint
        t.type = "mint"
      } else if (t.type == 1) { // burn
        t.type = "burn"
      } else if (t.type == 2) { // send
        t.type = "transfer"
      } else if (t.type == 3) { // receive
        t.type = "transfer"
        t.from_address = t.rid
        t.to_address = t.address
      } else if (t.type == 4) { // deposit
        t.type = "deposit"
      } else if (t.type == 5) { // withdraw
        t.type = "withdraw"
      } else if (t.type == 6) { // pay
        t.type = "payment"
      } else if (t.type == 7) { // refund
        t.type = "refund"
        t.from_address = t.rid
        t.to_address = t.address
      } else if (t.type == 8) { // prune pay
        t.type = "prune/pay"
      } else if (t.type == 9) { // prune fee
        t.type = "prune/fee"
      } else if (t.type == 10) { // wrap
        t.type = "wrap"
      } else if (t.type == 11) { // unwrap
        t.type = "unwrap"
      } else if (t.type == 12) { // wrap complete
        t.type = "wrap/complete"
      } else if (t.type == 13) { // unwrap complete
        t.type = "unwrap/complete"
      } else if (t.type == 14) { // wrap(payment)
        t.type = "wrap(payment)"
      } else if (t.type == 15) { // wrap(payment)/complete
        t.type = "wrap(payment)/complete"
      }
    }
  }
};

const getFuncOf = name => {
  return convertFuncPack[name];
};

const convertedAttrByView = {
  TransactionDetail: [getFuncOf("amount")],
  PendingBalance: [getFuncOf("amount")],
  Account: [getFuncOf("amount")],
  BlocksList: [getFuncOf("timeDiff")],
  TransactionsList: [getFuncOf("timeDiff"), getFuncOf("amount")],
  TransfersList: [getFuncOf("timeDiff"), getFuncOf("amount"), getFuncOf("balanceLogToTransfer")],
  RichAccountsList: [getFuncOf("timeDiff")],
};

export const convertAmountFormat = amount => {
  let hashExponentialNum = includes(amount);

  if (hashExponentialNum) {
    amount = convertDigits(amount);
  }

  return amount;
};

export const convertAttrFormat = (view, target) => {
  const funcs = convertedAttrByView[view];

  funcs.forEach(func => {
    func(target);
  });

  return target;
};

export const ellipsis = (str, len) => {
  if (!str) {
    return str
  }

  return str.slice(0, len) + "..." + str.slice(-len)
}



// WEBPACK FOOTER //
// ./src/js/format.js